import styled from 'styled-components'

const Divider = styled.hr`
  height: 1px;
  border: none;
  background-color: ${({ theme }) => theme.colors.gray[30]};
`

export default Divider
